import React from 'react';
import './Loading.css';

const Loading = (props) => {
    return (
        <div className={`Loading ${props.hidden && 'hidden'}`}>
            <div className="loading1 loadingCircle"></div>
            <div className="loading2 loadingCircle"></div>
            <div className="loading3 loadingCircle"></div>
        </div>
    );
};

export default Loading;